import type { ReactNode } from "react";
import styles from "./Container.module.css";

interface ContainerProps {
  readonly children: ReactNode;
  readonly className?: string;
}

export function Container({ children, className }: ContainerProps) {
  return (
    <div className={`${styles.container} ${className ?? ""}`}>{children}</div>
  );
}
